import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

const queryCache = new QueryCache();

const mutationCache = new MutationCache();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
  queryCache,
  mutationCache,
});

export { queryClient };